$(document).ready(function () {
    $('.get-quote-btn').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();

        const nextURL = '/get-quote';
        const nextTitle = 'Get a quote';
        const nextState = {};
        // This will create a new entry in the browser's history, without reloading
        window.history.pushState(nextState, nextTitle, nextURL);
        // This will replace the current entry in the browser's history, without reloading
        window.history.replaceState(nextState, nextTitle, nextURL);
        //Stop the page from being scrollable behind the modal
        body.style.overflow = 'hidden';
        body.classList.remove('scroll-up');
        // Opening modal
        //$('.get-quote-modal').css('display', 'flex').fadeIn(3000);
        $('.get-quote-modal').css('display', 'flex').hide().fadeIn();
        $('.get-quote-container').show();
        $('.go-next').prop('disabled', true);
        $('.submit-btn').prop('disabled', true);

        $('.step-1').removeClass('completed');
        $('.step-2').removeClass('completed');
        $('.step-3').removeClass('completed');
        $('.step-2').removeClass('active');
        $('.step-3').removeClass('active');
    });

    $('.mobile-menu-btn-home').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();

        // Opening mobile menu
        $('.main-mobile-menu').toggle();
    });
    // open watch video
    $('.watch-vid-btn, .how-it-works-image-click-video').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        body.style.overflow = 'hidden';
        // body.classList.remove('scroll-down');
        body.classList.remove('scroll-up');

        // Opening video-modal menu
        $('.youtube-video-modal').css('display', 'flex');
    });
    // close watch video

    $('.close-icon').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        console.log('clicked');
        body.style.overflow = 'auto';

        // Close video-modal menu
        // $('.youtube-video-modal').removeClass('display', 'flex');
        $('.youtube-video-modal').hide();

        $('.yt-player-iframe').each(function () {
            this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        });
    });
});

// // Get the navbar
// var navbar = document.getElementById('navbar');
// let lastScroll = 0;

// window.addEventListener('scroll', () => {
// 	const currentScroll = window.scrollY;

// 	if (currentScroll <= 0) {
// 		body.classList.remove('scroll-up');
// 	}

// 	if (currentScroll > lastScroll && !body.classList.contains('scroll-down')) {
// 		body.classList.remove('scroll-up');
// 		body.classList.add('scroll-down');
// 	}

// 	lastScroll = currentScroll;
// });
